const Textarea = ({
  name,
  variant = "default",
  label,
  placeholder,
  value,
  onChange,
  className,
  labelClassName,
  bottomLabel,
  required = false,
  bottomLabelClassName,
}) => {
  const getVariantClassName = () => {
    let baseClassName = "";
    switch (variant) {
      case "default":
        baseClassName +=
          "bg-[#0000000A] outline-none border-none py-2 px-3 rounded-lg text-sm text-dark-blue resize-none h-[150px]";
        break;
      case "primary-blur":
        baseClassName +=
          "bg-[#F1F5FF] outline-none border-none py-2 px-3 rounded-lg text-sm text-dark-blue resize-none h-[150px]";
        break;
      case "ghost":
        baseClassName +=
          "bg-[#0000000D] outline-none border-none py-2 px-3 rounded-lg text-sm text-dark-blue resize-none h-[150px]";
        break;
    }

    baseClassName += className ? ` ${className} ` : "";
    return baseClassName;
  };

  const getPlaceholderColorClassName = () => {
    let baseClassName = "";
    switch (variant) {
      case "default":
        baseClassName += "placeholder:text-dark-blue ";
        break;
      case "primary-blur":
        baseClassName += "placeholder:text-dark-blue ";
        break;
      case "ghost":
        baseClassName += "placeholder:text-[#787474] ";
        break;
    }

    return baseClassName;
  };

  return (
    <div className="flex flex-col gap-2">
      {label && (
        <label className={`text-sm font-medium ${labelClassName}`}>
          {label} {required ? " *" : null}
        </label>
      )}
      <textarea
        name={name}
        placeholder={placeholder}
        className={`${getVariantClassName()} ${getPlaceholderColorClassName()}`}
        value={value}
        onChange={onChange}
      />
      {bottomLabel && (
        <p className={`text-sm text-dark-blue ${bottomLabelClassName}`}>
          {bottomLabel}
        </p>
      )}
    </div>
  );
};

export default Textarea;
